import axios from "../utils/axios";

export const getCreatorList = (payload) => {
    return axios.get(`/UnplannedMaintenance/GetListByCreator?statusArr=${payload}`);
};

export const getStatusList = () => {
    return axios.get(`/UnplannedMaintenance/GetStatusList`);
};

export const getCancelOrder = (payload) => {
    return axios.post(`/UnplannedMaintenance/Cancel?orderId=${payload}`);
};

export const getConfirmOrder = (payload) => {
    return axios.post(`/UnplannedMaintenance/Approve?taskId=${payload}`);
};

export const downloadExcelFile = (filter) => {
    return axios.post(`/UnplannedMaintenance/ExportTasks`, filter, {
        responseType: "blob",
    });
};